import { SettingsObject } from '@hooks/useSettings';

export const defaults: Partial<SettingsObject> = {
    showEcoFee: true,
    enableEnergyLabelLink: true,
};
